module.exports = __webpack_public_path__ + "img/heniu_JP.b711af0f.jpg";